module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp3_7016.e0aa54ed.png";